/* OVESSI — EU1 fallback: post-render EUR symbol position fix.
 * For pages where the active Shopify currency is EUR, this script
 * rewrites any "€NN" or "€NN.NN" / "€NN,NN" text nodes to put the
 * euro sign AFTER the amount with a non-breaking space:
 *   €35      -> 35 €
 *   €35.00   -> 35,00 €
 *   €1,234.50 -> 1.234,50 €  (with European-style thousands)
 *
 * Pure cosmetic: does not change underlying Liquid pricing logic.
 * Skips: script/style/noscript, data-* attributes, ovessi-bonus/retail
 * spans (which are IP-personalised and already updated to render
 * "NN €" via their data-eur attribute values).
 *
 * Deployed: 29 May 2026
 */
(function(){
  if (window.__LUV_EUR_FORMAT__) return;
  window.__LUV_EUR_FORMAT__ = true;

  function isEUR() {
    try {
      var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
      return c === 'EUR';
    } catch (e) { return false; }
  }

  // Match "€" followed by a number with optional decimal + thousands.
  // Stops at non-digit/non-separator after a valid number.
  var EUR_PATTERN = /€(\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{1,2})?)/g;

  // Reformat amount: keep digits as-is (Shopify already supplies them in the
  // visitor's locale-correct grouping). Just append "\u00A0€".
  function flip(match, amount) {
    return amount + '\u00A0\u20AC';
  }

  // Skip elements where we MUST NOT touch text:
  function shouldSkipNode(node) {
    var p = node.parentElement;
    while (p) {
      var tn = p.tagName;
      if (tn === 'SCRIPT' || tn === 'STYLE' || tn === 'NOSCRIPT' || tn === 'TEXTAREA') return true;
      // Skip IP-personalised spans — they self-manage via JS
      if (p.classList && (
            p.classList.contains('ovessi-bonus') ||
            p.classList.contains('ovessi-retail')
          )) return true;
      if (p.hasAttribute && (
            p.hasAttribute('data-luv-hero-bonus') ||
            p.hasAttribute('data-luv-syrf-bonus') ||
            p.hasAttribute('data-luv-hero-retail')
          )) return true;
      // Skip the country/currency selector form
      if (p.classList && p.classList.contains('localization-form__currency')) return true;
      p = p.parentElement;
    }
    return false;
  }

  function walkAndFix(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('\u20AC') === -1) return NodeFilter.FILTER_REJECT;
        if (shouldSkipNode(n)) return NodeFilter.FILTER_REJECT;
        return EUR_PATTERN.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    var cur;
    while ((cur = walker.nextNode())) nodes.push(cur);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      // Reset regex lastIndex before each replace (global flag stateful)
      EUR_PATTERN.lastIndex = 0;
      var fixed = n.nodeValue.replace(EUR_PATTERN, flip);
      if (fixed !== n.nodeValue) n.nodeValue = fixed;
    }
  }

  function run() {
    if (!isEUR()) return;
    walkAndFix(document.body);
  }

  // First pass after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Watch for dynamic updates (cart, AJAX product loads, etc.)
  var rafScheduled = false;
  function scheduleRun() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(function () {
      rafScheduled = false;
      run();
    });
  }

  // Observe DOM mutations — covers cart drawer updates, quick-buy, etc.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          scheduleRun();
          return;
        }
        if (muts[i].type === 'characterData') {
          scheduleRun();
          return;
        }
      }
    });
    function startObserver() {
      if (document.body) {
        mo.observe(document.body, { childList: true, subtree: true, characterData: true });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserver);
    } else {
      startObserver();
    }
  }

  // Re-run on cart update events (Shopify Dawn + most custom themes dispatch these)
  document.addEventListener('cart:update', scheduleRun);
  document.addEventListener('cart:refresh', scheduleRun);
  document.addEventListener('cart:change', scheduleRun);
  document.addEventListener('cart:open', scheduleRun);
})();
